import React, { Component } from 'react';
import uuid from 'react-uuid'

import { AuthContext } from "../../../components/Auth/AuthDataProvider.jsx";

import { 
  Box,
  Grid,
  Divider,
  IconButton,
  Tooltip,
} from '@material-ui/core';

import Icon from '@material-ui/core/Icon';
import CustomCheckbox from '../../../components/CustomFields/CustomCheckbox.jsx';
import { ReactComponent as EditIcon } from '../../../assets/img/icons/edit.svg';
import { ReactComponent as DeleteIcon } from '../../../assets/img/icons/delete.svg';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faPlus } from '@fortawesome/free-solid-svg-icons'
import CustomLabel from '../../../components/CustomFields/CustomLabel.jsx';
import CustomButton from '../../../components/CustomFields/CustomButton.jsx';
import CustomTooltip from '../../../components/Tooltip/CustomTooltip.jsx';
import CustomDialog from '../../../components/Dialog/CustomDialog.jsx';
import CustomFormDialog from '../../../components/Dialog/CustomFormDialog.jsx';
import CustomerAdminAccountForm from './CustomerAdminAccountForm.jsx';
import apiUtil from "../../../api/apiUtil.jsx";


export class CustomerAdminAccountList extends Component {
  static contextType = AuthContext;

  constructor(props){
    super(props);

    let preview = ((props.preview === true) || (props.preview === false)) ? props.preview : false;
    let items = (props.items && props.items.length > 0) ? props.items : [];

    this.state = {
      openDialogEdit: false,
      itemDialogEdit: null,

      openDialogDelete: false,
      itemDialogDelete: null,

      customer_info: items,
      preview: preview,
    }
  }
  

  componentWillReceiveProps(nextProps) {
    if (nextProps.items !== this.state.items) {
        let items = (nextProps.items && nextProps.items.length > 0) ? nextProps.items : [];
        this.setState({
            customer_info: items
        });
    }
  }


  /* FUNCTIONS */
  addNew = (form = null, callback = null) => {
    let customer_info = this.state.customer_info;

    if(form) {
        if(form.is_main){
            this.clearIsMain();
        }
        
        form['uuid'] = uuid();
        form['remove'] = false;
        customer_info.push(form);
    } else {
        let checkIsMain = this.checkIsMainExists();

        customer_info.push({
            uuid: uuid(),
            first_name: '',
            last_name: '',
            contact_no: '',
            email: !checkIsMain,
            address: false,
        });
    }
    
    this.setState({
        customer_info: customer_info
    }, () => {
        if(callback){
            callback();
        }

        if(this.props.onAddNew){
            this.props.onAddNew(this.state.customer_info);
        }
    });
  }

  edit = (item = null, form = null, callback = null) => {
    let customer_info = this.state.customer_info;

    let editIndex = customer_info.findIndex(e => e.uuid === item.uuid);
    if(editIndex !== -1){
        let oldForm = customer_info[editIndex];

        if(form.is_main){
            this.clearIsMain();
        }
        
        oldForm['uuid'] = item.uuid;
        oldForm['permanent_delete'] = false;
        oldForm['id'] = item.id;
        oldForm['first_name'] = form.first_name
        oldForm['last_name'] = form.last_name
        oldForm['is_not_allowed'] = form.is_not_allowed
        customer_info[editIndex] = oldForm;

        // oldForm['permanent_delete'] = true;
        // oldForm['is_main'] = false;
        // customer_info.push(oldForm);
    }
    
    this.setState({
        customer_info: customer_info
    }, () => {
        if(callback){
            callback();
        }

        if(this.props.onEdit){
            this.props.onEdit(this.state.customer_info);
        }
    });
  }

  remove = (uuid = '', callback = null) => {
    let customer_info = this.state.customer_info;
    let index = customer_info.findIndex(e => e.uuid === uuid);

    if(index !== -1){
        customer_info[index]['permanent_delete'] = true;
    }
    
    this.setState({
        customer_info: customer_info
    }, () => {
        if(callback){
            callback();
        }

        if(this.props.onRemove){
            this.props.onRemove(this.state.customer_info);
        }
    });
  }

  checkIsMainExists = () => {
    let customer_info = this.state.customer_info;

    if(customer_info && customer_info.length > 0){
        let isMain = customer_info.filter(x => !x.remove).filter(x => x.is_main === true);

        return (isMain && isMain.length > 0) ? true : false;
    }

    return false;
  }
  clearIsMain = () => {
    let customer_info = this.state.customer_info;

    if(customer_info && customer_info.length > 0){
        let isMain = customer_info.filter(x => x.is_main === true);

        if(isMain && isMain.length > 0){
            customer_info = customer_info.map((item, i) => {
                item.is_main = false;
                return item;
            });
        }
    }
  }
  /* END FUNCTIONS */

  

  /* DIALOG */
  editDialog = () => {
      return <CustomFormDialog 
          open={this.state.openDialogEdit}
          title={'Edit Customer Admin Account'}
          onClose={() => {
            this.setState({
                openDialogEdit: false,
                itemDialogEdit: null,
            });
          }}
      >
          <CustomerAdminAccountForm
            item={this.state.itemDialogEdit}
            allItems={this.state.customer_info}
            onSave={(isEdit, form) => {
                let item = this.state.itemDialogEdit;

                if(isEdit) {
                    this.edit(item, form, () => {
                        this.setState({
                            openDialogEdit: false,
                            itemDialogEdit: null,
                        });
                    });
                } else {
                    this.addNew(form, () => {
                        this.setState({
                            openDialogEdit: false,
                            itemDialogEdit: null,
                        });
                    });
                }
                
            }}
            onClose={() => {
                this.setState({
                    openDialogEdit: false,
                    itemDialogEdit: null,
                });
            }}
          />
      </CustomFormDialog>
  }

  deleteDialog = () => {
      return <CustomDialog 
          open={this.state.openDialogDelete}
          title={'Delete'}
          onClose={() => {
            this.setState({
                openDialogDelete: false,
                itemDialogDelete: null,
            });
          }}
          onOk={() => {
              let item = this.state.itemDialogDelete;
    
              if(this.props.checkExistOrders) {
                  this.props.checkExistOrders(item.id, (data) => {
                    if(data.result) {
                      apiUtil.toast("Client order exist!. You can not delete this customer", 'check_circle');
                      this.setState({
                          openDialogDelete: false,
                          itemDialogDelete: null,
                      });
                    } else {
                      this.remove(item.uuid, () => {
                        this.setState({
                            openDialogDelete: false,
                            itemDialogDelete: null,
                        });
                      });
                    }                        
                  });
              } else {
                this.remove(item.uuid, () => {
                  this.setState({
                      openDialogDelete: false,
                      itemDialogDelete: null,
                  });
                });                  
              }
          }}
      >
          <Box>Are you sure you want to delete?</Box>
      </CustomDialog>
  }
  /* END DIALOG */


  render() {
    return <Box pt={5} pb={5}>
        <Grid container>
            {!this.state.preview && <Grid item xs={12}>
                <CustomLabel
                    label={'Customer admin account'}
                    weight={'bold'}
                    size={'md'}
                    labelComponent={<CustomTooltip title={'remark'} />}
                />
                <Divider light />
            </Grid>}
            <Grid item xs={12}>
                <Box>

                    {
                        (this.state.customer_info && this.state.customer_info.length > 0 && this.state.customer_info.filter(x => !x.permanent_delete).length > 0)
                        ?
                        this.state.customer_info.filter(x => !x.permanent_delete).map((item, i) => {
                            return <Box key={i} pt={1} pb={1}>
                                <Grid container alignItems={'center'}>
                                    <Box clone>
                                        <Grid item xs={12} md={3} style={{overflowWrap: 'break-word', wordBreak: 'break-all', display:'inline-block'}}>
                                            <CustomLabel
                                                label={<Box>
                                                    <Tooltip title={'First Name'} placement={'top'}>
                                                        <Box>{item.first_name}</Box>
                                                    </Tooltip>
                                                </Box>}
                                            />
                                        </Grid>
                                    </Box>
                                    <Box clone>
                                        <Grid item xs={12} md={3} style={{overflowWrap: 'break-word', wordBreak: 'break-all', display:'inline-block'}}>
                                            <CustomLabel
                                                label={<Box>
                                                    <Tooltip title={'Last Name'} placement={'top'}>
                                                        <Box>{item.last_name}</Box>
                                                    </Tooltip>
                                                </Box>}
                                            />
                                        </Grid>
                                    </Box>
                                    <Box clone>
                                        <Grid item xs={12} md={3} style={{overflowWrap: 'break-word', wordBreak: 'break-all', display:'inline-block'}}>
                                            <CustomLabel
                                                label={<Box>
                                                    <Tooltip title={'email'} placement={'top'}>
                                                        <Box>{item.email}</Box>
                                                    </Tooltip>
                                                </Box>}
                                            />
                                        </Grid>
                                    </Box>
                                    <Box clone>
                                        <Grid item xs={12} md={2}>
                                        <CustomCheckbox
                                            label={"own order only"}
                                            disabled={true}
                                            checked={item.is_not_allowed}
                                        />
                                        </Grid>
                                    </Box>
                                    {!this.state.preview && <Box clone pr={{ xs: 0, md: 2}}>
                                        <Grid item xs={12} md={1}>
                                            <Grid container justify={'flex-end'}>
                                                <Box clone>
                                                    <Grid item xs={'auto'}>
                                                        <IconButton
                                                            onClick={() => {
                                                                this.setState({
                                                                    openDialogEdit: true,
                                                                    itemDialogEdit: item,
                                                                });
                                                            }}
                                                        >
                                                            <EditIcon />
                                                        </IconButton>
                                                    </Grid>
                                                </Box>
                                                <Box clone>
                                                    <Grid item xs={'auto'}>
                                                        <IconButton
                                                            onClick={() => {
                                                                this.setState({
                                                                    openDialogDelete: true,
                                                                    itemDialogDelete: item,
                                                                });
                                                            }}
                                                        >
                                                            <DeleteIcon />
                                                        </IconButton>
                                                    </Grid>
                                                </Box>
                                            </Grid>
                                        </Grid>
                                    </Box>}
                                </Grid>
                                <Divider light />
                            </Box>
                        })
                        :
                        <Grid container>
                            <Box clone pt={3} textAlign={'center'}>
                                <Grid item xs={12}>
                                    <CustomLabel
                                        label={'No Results!'}
                                        weight={'bold'}
                                    />
                                </Grid>
                            </Box>
                        </Grid>
                    }

                    {/* {!this.state.preview && this.state.customer_info.filter(x => !x.permanent_delete).length < 1 && <Grid container> */}
                    {!this.state.preview && <Grid container>
                        <Box clone>
                            <Grid item xs={12}>
                                <CustomButton 
                                    color={'primary'}
                                    href={'/'}
                                    onClick={(e) => {
                                        e.preventDefault();

                                        this.setState({
                                            openDialogEdit: true,
                                            itemDialogEdit: null,
                                        });
                                    }}
                                >
                                     <FontAwesomeIcon icon={faPlus} component={'i'} />
                                    {/* <Icon component={'i'}>add</Icon> */}
                                    <Box display={'inline-block'} pl={1}>Add New Customer Admin Account</Box>
                                </CustomButton>
                            </Grid>
                        </Box>
                    </Grid>}

                </Box>
            </Grid>
        </Grid>
        {this.editDialog()}
        {this.deleteDialog()}
    </Box>
  }
}

export default CustomerAdminAccountList;